import { axiosInstance } from 'app/utils/axiosConfig'
import { User } from 'EstraSponsor'

import { endpoints } from './endpoints'

export type GetUserFromTokenPayload = {
  invitation_token: string
}

export type GetUserFromTokenResponse = User

export const getUserFromToken = async (
  data: GetUserFromTokenPayload
): Promise<GetUserFromTokenResponse> => {
  return axiosInstance
    .get(endpoints.getUserFromToken, {
      params: { invitation_token: data.invitation_token },
    })
    .then(({ data }) => data)
}

export type ConfirmInvitationPayload = {
  api_v1_user: {
    invitation_token: string
    password: string
    password_confirmation: string
  }
}

export type ConfirmInvitationResponse = User

export const confirmInvitation = async (
  data: ConfirmInvitationPayload
): Promise<ConfirmInvitationResponse> => {
  return axiosInstance.put(endpoints.confirmInvitation, data)
}
